<template>
    <section class="px-6 py-2 md:px-10 flex justify-between items-center text-ink font-gotham">
        <p
            :class="{ 'text-red': cartErrors && inErrorState && !selectionsComplete }"
            class="font-semibold"
        >
            {{ totalSelectionsMade }}/{{ totalSteps }} {{ $t('COMPLETED') }}
        </p>

        <view-all-button class="lg:cz-hidden" />

        <reset-button class="cz-hidden lg:flex" />
    </section>
</template>

<script>
    import allStores from '../stores/all';

    import ResetButton from './ResetButton.vue';
    import ViewAllButton from './ViewAllButton.vue';

    export default {
        mixins: [allStores],

        components: {
            ResetButton,
            ViewAllButton,
        },

        computed: {
            inErrorState() {
                return this.customizerStore.inErrorState;
            },

            cartErrors() {
                return this.customizerStore.cartErrors;
            },

            totalSteps() {
                return this.customizerStore.visibleGroups.length;
            },

            totalSelectionsMade() {
                return this.customizerStore.totalSelectionsMade;
            },

            selectionsComplete() {
                return this.customizerStore.selectionsComplete;
            },

            disableEdit() {
                return this.customizerStore.disableEdit;
            },
        },
    };
</script>
